<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-form ref="form" lazy-validation>
      <v-row>
        <v-col cols="12" lg="6">
          <v-toolbar-title class="mb-2">Main Informations</v-toolbar-title>
          <v-card elevation="3" class="mb-3 pt-3 pb-3">
            <v-text-field
              :rules="[rules.required, rules.maxvalue]"
              v-model="categoryname"
              class="mx-3"
              label="Category Name"
              outlined
              dense
              @keyup.enter="submit"
            ></v-text-field>
            <v-text-field
              :disabled="true"
              v-model="parentCatName"
              value="Main Category"
              class="mx-3"
              label="Parint"
              outlined
              dense
            ></v-text-field>
            <v-switch
              class="mx-3"
              v-model="status"
              label="Status"
              color="primary"
              hide-details
            ></v-switch>
          </v-card>

          <v-btn
            @click="submit"
            depressed
            color="primary"
            class="float-sm-right"
            :loading="loadingAdd"
          >
            Save
          </v-btn>
        </v-col>
        <v-col cols="12" lg="6">
          <v-skeleton-loader
            v-if="listLang.length == 0"
            type="article , article"
          ></v-skeleton-loader>
          <div v-else>
            <v-toolbar-title class="mb-2"
              >Category Name Translate</v-toolbar-title
            >
          </div>

          <div v-for="(item, index) in listLang" :key="index">
            <v-card elevation="3" class="mb-3">
              <v-chip
                class="ma-2 mt-3 ml-3"
                color="green"
                label
                text-color="white"
              >
                {{ item.langname }}
              </v-chip>

              <v-text-field
                :rules="[rules.required]"
                class="mx-3"
                v-model="translate.categorynametrans[item.langcode]"
                label="Category Name By Trans"
                outlined
                dense
                @keyup.enter="submit"
              ></v-text-field>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
export default {
  props: ["item"],
  data() {
    return {
      rules: {
        required: (value) => !!value || "Field required.",
        maxvalue: (value) =>
          value.length <= 64 || "Maximum length is 64 characters",
      },

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Categories",
          disabled: false,
          to: "/categories",
        },
        {
          text: "Add Category",
          disabled: true,
        },
      ],
      loadingAdd: false,
      listLang: [],
      categoryname: "",
      parentCatName: "",
      status: true,
      translate: {
        categorynametrans: {},
      },
      categoryDetail: {},
    };
  },

  components: {
    Breadcrumbs,
  },

  mounted() {
    this.getAllLang();
    if (this.$route.params.parentID) {
      this.getCategoryDetail();
    }else{
      this.parentCatName = "Root"
    }
  },

  methods: {
    submit() {
      if (this.$refs.form.validate() != false) {
        this.loadingAdd = true;
        let DataForm = {
          Param: {
            categoryname: this.categoryname,
            status: this.status,
            parent_id: this.$route.params.parentID,
            translate: this.translate,
          },
          API: "/admin/category",
        };
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then((response) => {
            this.$store.dispatch("PushSuccessMsg", response.data.message);
            this.loadingAdd = false;
            this.$router.push({ name: "Category" }).catch(() => {});
          })
          .catch(() => {
            this.loadingAdd = false;
            this.$store.dispatch("PushErrorMsg", "Validation Error");
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/admin/lang").then((response) => {
        this.listLang = response["data"]["data"];
      });
    },
    getCategoryDetail() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/category/" + this.$route.params.parentID
        )
        .then((response) => {
          this.categoryDetail = response["data"]["data"];
          this.parentCatName = this.categoryDetail.categoryname;
        });
    },
  },
};
</script>